<template>
    <div class="card h-100 rounded-0 border-0 select-trash-type" :class="animation">
        <div class="card-body text-center h-100 p-0">
            <div class="row">
                <BackButton @click.native="handleBackToStep()" />
            </div>
            <div class="row">
                <div class="form-wrap-step">
                    <div class="">
                        <h5 class="title__normal">ゴミの種類を選択してください。</h5>
                    </div>
                </div>
            </div>
            <div class="form-wrap-step">
                <form>
                    <div class="container select-wrapper">
                        <div v-for="(trashItem, index) in formData" :key="index" class="row align-items-center">
                            <div class="col-3 appliance-type mb-1">
                                <Select2 
                                    :options="productOptions" 
                                    v-model="trashItem.productId"
                                    @change="onSelectProduct(trashItem.productId, trashItem)"
                                    placeholder="--選択してください--" 
                                    :settings="{ 
                                        allowClear: true,
                                        language: {
                                            noResults: function () {
                                                return '一致する結果はありません';
                                            }
                                        }
                                    }"
                                />
                            </div>
                            <div class="col-7 appliance-type mb-1">
                                <Select2
                                    :name="trashItem.name" 
                                    :options="trashItem.trashOptions"
                                    v-model="trashItem.value"
                                    @change="onSelect(trashItem)" 
                                    placeholder="--選択してください--"
                                    :settings="{
                                        allowClear: true, 
                                        language: {
                                            noResults: function () {
                                                return '一致する結果はありません';
                                            }
                                        } 
                                    }"
                                />
                            </div>
                            <div class="col-2 appliance-type quantity-width">
                                <div class="form-input-adjustable d-flex bag-group justify-content-center">
                                    <span class="before-bag" @click="onDecreaceQty(trashItem)"></span>
                                    <input :name="trashItem.name" v-model="trashItem.quantity" inputmode="numeric" min="0"
                                        type="number" step="1" class="form-control bag_number_input"
                                        @change="onChangeQty(trashItem)"
                                        onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'">
                                    <span class="after-bag" @click="onIncreaceQty(trashItem)"></span>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-md-12">
                                <div class="font-medium text-right content__normal">
                                    <div class="d-flex justify-content-end">
                                       <div class="pr-2 w-100" style="max-width: 280px;">
                                            <h5 class="m-1 qty-bag d-flex justify-content-between">
                                                <span class="text-green font-w-600">基本料金:</span>
                                                <span>{{ processingFee ?? '' }}円</span>
                                            </h5>
                                            <h5 class="m-1 qty-bag  d-flex justify-content-between">
                                                <span class="text-green font-w-600">収集運搬料:</span>
                                                <span>{{ transportationPrice ?? '' }}円</span>
                                            </h5>
                                            <h5 class="m-1 qty-bag d-flex justify-content-between">
                                                <span class="text-green font-w-600">お見積もり金額合計:</span>
                                                <span>
                                                    {{ totalPrice ?? '' }}円
                                                    <span id="totalPrice"></span>
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <span class="d-block text-center text-danger my-3">
                                        表示している料金は1階の入り口に一時多量ごみが運び出しが可能な状態をさします。<br>
                                        1階以外からの集荷や屋内からの運び出しは別途費用を申し受けます。
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-bottom:0.7rem;">
                            <div class="col-md-2"></div>
                            <div class="col-md-8 text-center below-adv-btn">
                                <button 
                                    type="button" 
                                    class="btn btn-yellow-dark px-5 d-inline-block btn-lg rounded-1"
                                    :disabled="isDisabled"
                                    @click="handleClick()"
                                    >
                                    <span class="text">次へ</span>
                                </button>
                            </div>
                            <div class="col-md-2"></div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import BackButton from '.././BackButton.vue';
export default {
    name: 'TypeOfAppliance',
    props: {
        animation: {
            default: ''
        },
        allData: {
            default: ''
        },
        formValue: {
            default: ''
        }
    },
    data() {
        return {
            productOptions: [],
            formData: [
                {
                    name: 'trashItem1',
                    productId: this.allData.orders[0]?.productId || '',
                    trashOptions: this.allData.orders[0]?.trashOptions || [],
                    value: this.allData.orders[0]?.value || '',
                    fee: this.allData.orders[0]?.fee || '', 
                    transportationFee: this.allData.orders[0]?.transportationFee || '',
                    quantity: this.allData.orders[0]?.quantity || 0 
                },
                {
                    name: 'trashItem2',
                    productId: this.allData.orders[1]?.productId || '',
                    trashOptions: this.allData.orders[1]?.trashOptions || [],
                    value: this.allData.orders[1]?.value || '',
                    fee: this.allData.orders[1]?.fee || '',
                    transportationFee: this.allData.orders[1]?.transportationFee || '',
                    quantity: this.allData.orders[1]?.quantity || 0  
                },
                {
                    name: 'trashItem3',
                    productId: this.allData.orders[2]?.productId || '',
                    trashOptions: this.allData.orders[2]?.trashOptions || [],
                    value: this.allData.orders[2]?.value || '',
                    fee: this.allData.orders[2]?.fee || '',
                    transportationFee: this.allData.orders[2]?.transportationFee || '',
                    quantity: this.allData.orders[2]?.quantity || 0 
                }
            ],
            isDisabled: true,
            transportationPrice:0,
            totalPrice: 0,
            NO_COLLECTED: 0,
            processingFee: 0
        }
    },
    methods: {
        async getHouseholdProduct() {
            const parentId = 4;
            await axios.get(`api/trash/house-hold-products/${parentId}`)
                .then(response => {
                    response.data.map(product => {
                        this.productOptions.push({
                            id: product.id,
                            text: product.name,
                        })
                    });
                })
                .catch(err => console.error(err));  
        },
        async onSelectProduct(productId, trashItem) {
            trashItem.trashOptions = [];
            trashItem.quantity = 0;
            trashItem.value = '';
            if (productId == null) {
                trashItem.quantity = 0;
                trashItem.value = '';
                trashItem.productId = '';
                let countSelected = 0;
                this.formData.map(item => {
                    if (item.productId === '') countSelected++;
                })
                if (countSelected === 3) {
                    this.isDisabled = true;
                } else {
                    this.onDisabledButton();
                }

                return;
            }
            const trashSizeMap = [
                {
                    text: ''
                },
                {
                    text: '小'
                },
                {
                    text: '大'
                }
            ]
            await axios.get(`api/trash/house-hold-garbages/${productId}`)
                .then(response => {
                    response.data.map(item => {
                        const size = item.trash_type_size != 0 ? ` (${trashSizeMap[item.trash_type_size].text}) ` : '';
                        const feeFormatted = new Intl.NumberFormat('ja-JP').format(item.processing_fee);
                        const fee = ` (${feeFormatted}円)`;
                        trashItem.trashOptions.push({
                            id: item.trash_type_id,
                            text: item.name + size + fee,
                            fee: item.processing_fee,
                            transportationFee: item.transportation_fee
                        })
                    });

                })
                .catch(err => console.error(err));
            this.onDisabledButton();
        },      
        onSelect(trashSelected) {
            if (trashSelected.value == null) {
                trashSelected.quantity = 0
                this.onDisabledButton();

                return;
            }

            if (trashSelected.value == 0) trashSelected.quantity = 0;
            trashSelected.fee = trashSelected.trashOptions.find(item => item.id == trashSelected.value).fee;
            trashSelected.transportationFee = trashSelected.trashOptions.find(item => item.id == trashSelected.value).transportationFee;
            if (trashSelected.value != 0) {
                trashSelected.quantity == 0 && trashSelected.quantity++;
            }

            this.onDisabledButton();
        },
        onCalcFeeTotal() {
            const totalQuantity = this.formData.reduce((total, item) => total + (item.quantity || 0), 0);
            const feeDefault = 4400;
            let processingFee = 0;
            let transportationFee = 0;

            this.formData.map(item => {
                if (item.quantity > 0) {
                    processingFee += item.fee * item.quantity;
                    transportationFee += feeDefault * item.quantity;
                }
            });
            transportationFee += totalQuantity && feeDefault;
            this.transportationPrice = new Intl.NumberFormat('ja-JP').format(transportationFee);
            this.totalPrice = new Intl.NumberFormat('ja-JP').format(processingFee + transportationFee);
            this.processingFee = processingFee;
        },
        onIncreaceQty(trashItem) {
            this.formData.map(item => {
                return item.name === trashItem.name && trashItem.value != '' && trashItem.value != 0 && trashItem.quantity < 10 && item.quantity++
            })
        },
        onDecreaceQty(trashItem) {
            this.formData.map(item => {
                return item.name === trashItem.name && item.quantity > 1 && item.quantity--
            })
        },
        onChangeQty(trashItem) {
            if (typeof trashItem === 'undefined') return;
                
            if (trashItem.quantity <= 0) {
                if (trashItem.value == '' || trashItem.value == 0) trashItem.quantity = 0;
                if (trashItem.value != '' || trashItem.value != 0) trashItem.quantity = 1;
            }
            if (trashItem.value == 0) {
                trashItem.quantity = 0;
            }

            if (trashItem.quantity > 10) {
                trashItem.quantity = 10
            }
        },
        onDisabledButton() {
            let selections = [];
            this.formData.map(item => {
                selections.push({
                    isDisabled: (item.productId && item.value) || (!item.productId && !item.value) ? false : true
                })
            })

            for(let selection of selections) {
                if (selection.isDisabled) {
                    this.isDisabled = true;
                    break;
                }

                this.isDisabled = false;
            }
        },
        handleBackToStep() {
            const currentStep = 2;
            const followStep = 0;
            this.$emit("handleChangeStep", currentStep, followStep);
        },
        async handleClick() {
            await this.handleBindingData();
            // const currentStep = 2;
            // const followStep = 2;
            // this.$emit("handleChangeStep", currentStep, followStep);
            await this.postData();
        },
        handleBindingData() {
            let payload = {
                label: 'trashAppliance',
                data: {
                    orders: [...this.formData],
                    totalPrice: this.totalPrice
                }
            };
            payload = JSON.parse(JSON.stringify(payload));
            this.$emit('onChangeFormValue', payload);
        },
        async postData() {
            this.data = {
                ...this.formValue,
                is_collect: this.NO_COLLECTED,
            };
            console.log(this.data);
            let res = await axios.post(`/api/register/register-info/`, this.data);
            if (res.data.success) {
                window.location.href = '/order/order-oversized-step-company';
            } else {
                alert('Failed to continue');
            }
        },
    },
    created() {
        if (this.allData.orders.length > 0) {
            this.isDisabled = false;
        }
        this.getHouseholdProduct();
    },
    updated() {
        this.onChangeQty()
        this.onCalcFeeTotal();
    },
    components: { 
        BackButton 
    }
}
</script>